<template>
  <div class="visitorAnalyze" ref="visitorAnalyze">
    <div class="ChartModeBox everItem">
      <div class="headerTitle">退货原因分布情况</div>
      <div class="ChartBox">
        <dashboard-chart :dataset="returnReasonDistributionData" :title="'总退货数'" v-if="returnReasonDistributionData && returnReasonDistributionData.length > 0"  />
        <div v-else style="text-align: center;line-height: 20px;">暂无数据</div>
      </div>
      <van-grid v-if="returnReasonDistributionData && returnReasonDistributionData.length > 0" :border="false" :column-num="3" class="processing-satisfaction">
        <van-grid-item v-for="(item, index) in returnReasonDistributionData" :key="index" @click="toCommonList(returnReasonOption[item.refund_reason], index, 'reason')">
          <div class="type">
            <p class="round" :style="{'background-color': returnReasonOption[item.refund_reason].color}"></p>
            <span>{{ returnReasonOption[item.refund_reason].name }}</span>
          </div>
          <p class="percentage">{{ item.proportion }}</p>
          <div class="number">
            <span>{{ item.count || 0 }}起</span>
            <van-icon name="arrow" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>



    <div class="tripMode everItem">
      <div class="headerTitle">出行方式分布情况</div>
      <div class="doucghnutChartBox">
        <div>
          <doughnut-chart :travelModeInfo="travelModeInfo"></doughnut-chart>
        </div>
        <div class="doughnutDetail">
          <div
            class="itemBox"
            v-for="(item, keys) in travelModeInfo"
            :key="keys"
            @click="toCommonList(item, keys, 'info')"
          >
            <div class="topBox">
              <span
                class="iconBox"
                :style="{ backgroundColor: item.itemStyle.color }"
              ></span>
              <span class="nameBox">{{ item.name }}</span>
              <span class="percent">{{ item.proportion }}</span>
            </div>
            <div class="bottomBox" @click="toList(item)">
              <span class="numBox">{{ item.value || 0 }}起</span>
              <span class="icon"><van-icon color="#71747a" name="arrow"/></span>
            </div>
          </div>
        </div>
        
      </div>
    </div>

    <div class="sourceMode everItem">
      <div class="headerTitle">来源地分布TOP10</div>
      <div class="BarChart">
        <bar-chart bottom="4%" :dataset="datasetBar"></bar-chart>
      </div>
      <!-- <div v-if="source.length != 0" style="padding-left: 16px;font-size: 16px;color: #71747A;font-weight: 400;">暂无数据</div> -->
    </div>

    <div class="ageMode everItem">
      <div class="headerTitle">年龄分布情况</div>
      <div class="RefererChart">
        <referer-chart :travelModeInfo="touristAgeInfo"></referer-chart>
      </div>
    </div>

    <div class="ChartModeBox everItem">
      <div class="headerTitle">选择渠道分布情况</div>
      <div class="ChartBox">
        <dashboard-chart :title="'总退货数'" :dataset="appRefundChannelData" v-if="appRefundChannelData && appRefundChannelData.length > 0"  />
      </div>
      <van-grid :border="false" :column-num="3" class="processing-satisfaction">
        <van-grid-item v-for="(item, index) in appRefundChannelData1" :key="index" @click="toCommonList(item, index, 'channel')">
          <div class="type">
            <p class="round" :style="{'background-color': appRefundChannelColor[item.name]}"></p>
            <span>{{ item.name }}</span>
          </div>
          <p class="percentage">{{ item.proportion }}</p>
          <div class="number">
            <span>{{ item.count || 0 }}起</span>
            <van-icon name="arrow" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="salesMean everItem">
      <div class="itemTitleBox">
        平均每位游客退货<img @click="titleMean" src="../../../../assets/refund/whyTip.png" alt />
      </div>
      <div class="numBox">{{ avgTourist || 0 }}<span>起</span></div>
    </div>
  </div>
</template>

<script>
    import DoughnutChart from './chartComponent/DoughnutChart.vue';
    import dashboardChart from './chartComponent/dashboardChart.vue';
    import RefererChart from './chartComponent/RefererChart';
    import BarChart from './chartComponent/BarChart';
    import API from '@/service/modules/refund';

    import Vue from 'vue';
    import { Dialog } from 'vant';
    Vue.use(Dialog);

    export default {
        data () {
            return {
                currentUserState: '',
                userInfo: {},
                travelModeInfo: [],
                datasetBar: [],
                touristAgeInfo: [],
                returnReasonDistributionData: [],
                requireData: {
                    dataType: 0,
                    endTime: this.$store.state.refund.statisticalAnalysisTime.endTime,
                    liftingSequence: '',
                    orgId: '',
                    reginCode: this.$store.state.refund.statisticalAnalysisReginCode,
                    sort: '',
                    startTime: this.$store.state.refund.statisticalAnalysisTime.startTime,
                    value: ''
                },
                returnReasonOption: [
                    { name: '', color: '' },
                    { name: '价格虚高', color: '#939CE6' },
                    { name: '瑕疵商品', color: '#66AEF8' },
                    { name: '发票/收据不正规', color: '#FF8C7F' },
                    { name: '导游强制购物', color: '#3BC07C' },
                    { name: '不喜欢', color: '#FFB469' },
                    { name: '其他', color: '#71D9E1' }
                ],
                appRefundChannelData: [], // 选择渠道分布统计
                appRefundChannelData1: [
                    { code: 10 },
                    { code: 1 },
                    { code: 2 },
                    { code: 3 },
                    { code: 8 },
                    { code: 4 }
                ],
                appRefundChannelColor: {
                    '小程序在线退货': '#939CE6',
                    'App语音退货': '#71D9E1',
                    'App在线退货': '#3BC07C',
                    '诚信码退货': '#FFB469',
                    '96301电话退货': '#66AEF8',
                    '退货中心退货': '#FF8C7F'
                    // '系统录入': '#FF8C7F'
                },
                avgTourist: '',
                source: []
            };
        },
        components: {
            DoughnutChart,
            RefererChart,
            BarChart,
            dashboardChart
        },
        created() {
          this.currentUser();
          
        },
        mounted () {
            // this.currentUser();
        },
        methods: {
            currentUser () {
                API.currentUser().then((res) => {
                    if (this.currentUserState == 'loading') return;
                    this.currentUserState = 'loading';
                    if (res.ret === 0) {
                        this.currentUserState = 'success';
                        this.userInfo = res.data;
                        // this.requireData['reginCode'] = this.userInfo && this.userInfo.regionCode ? this.userInfo.regionCode : '';
                        this.getInfo();
                    } else {
                        this.currentUserState = 'fail';
                        this.userInfo = { reginCode: '' };
                    }
                });
            },
            // 出行方式跳转列表
            toList (item) {

            },
            // 游客出行方式分布
            getTravelMode () {
                this.travelModeInfo = [];
                API.getTravelMode(this.requireData).then((res) => {
                    if (res.ret === 0) {
                        let colors = '#44C885';
                        res.data.travelModeMap.forEach((item) => {
                            // this.travelModeInfo.push({
                            //     value: item.count,
                            //     name: item.type,
                            //     itemStyle: {
                            //         color: colors
                            //     },
                            //     proportion: item.proportion
                            // });

                                item.value = item.count,
                                item.name = item.type,
                                item.itemStyle = {
                                    color: colors
                                },
                                item.proportion = item.proportion

                            colors = '#71D9E1';
                        });
                        this.travelModeInfo = res.data.travelModeMap
                    }
                });
            },
            // 来源地分布TOP10
            getTouristSource () {
                this.datasetBar = []
                API.getTouristSource(this.requireData).then((res) => {
                    if (res.ret === 0) {
                        // let source = [];
                        this.source = []
                        res.data.touristSourceMap &&
                            res.data.touristSourceMap.forEach((item) => {
                                this.source.push([item.name, item.count]);
                            });
                              this.datasetBar = [
                                  {
                                      dimensions: ['name', 'value'],
                                      source: this.source
                                  },
                                  {
                                      transform: {
                                          type: 'sort',
                                          config: { dimension: 'value', order: 'desc' }
                                      }
                                  }
                              ];

                    }
                    console.log('this.datasetBar==== ', this.datasetBar);
                });
            },
            // 年龄分布情况
            getTouristAge () {
                this.touristAgeInfo = [];
                API.getTouristAge(this.requireData).then((res) => {
                    if (res.ret === 0) {
                        let colors = [
                            '#44C885',
                            '#66AEF8',
                            '#939CE6',
                            '#FFB469',
                            '#FF8C7F',
                            '#71D9E1'
                        ];
                        res.data.ageMap.forEach((item, index) => {
                            let idx = index;
                            if (idx > 5) idx = 5;
                            // this.touristAgeInfo.push({
                            //     value: item.count,
                            //     name: item.age_section,
                            //     itemStyle: { color: colors[idx] }
                            // });
                                 item.value = item.count
                                item.name = item.age_section,
                               item.itemStyle = { color: colors[idx] }
                            console.log('touristAgeInfo', this.touristAgeInfo);
                        });
                        this.touristAgeInfo = res.data.ageMap
                    }
                });
            },
            // 请求所有图表数据
            async getInfo (from = '') {
                console.log(this.requireData.reginCode, 'HIfhhg')
                if ((this.currentUserState == 'fail' || this.currentUserState == 'loading') && from == '') {
                    this.currentUser();
                    return;
                }
                console.log(this.requireData.reginCode, 'hntnhkn')
                this.getTravelMode(); // 游客出行方式分布
                this.getTouristSource(); // 来源地分布TOP10
                this.getTouristAge(); // 年龄分布情况
                await this.returnReasonDistribution() // 退货原因分布
                this.appRefundChannel()
                this.avgTouristRefund()
            },
            avgTouristRefund () {
                // this.requireData["reginCode"] = this.userInfo.regionCode;
                this.avgTourist = ''
                API.avgTouristRefund(this.requireData).then(r => {
                    if (r.ret === 0) {
                        this.avgTourist = r.data
                    } else {
                        this.avgTourist = ''
                    }
                })
            },
            appRefundChannel () {
                this.appRefundChannelData = [];
                API.appRefundChannel(this.requireData).then(r => {
                    if (r.ret === 0 && r.data) {
                      console.log('r.data', r.data.length);
                      let num = 0
                        for (let key in r.data) {
                          num++
                            r.data[key].count = r.data[key].num
                            r.data[key].color = this.appRefundChannelColor[r.data[key].name]
                            this.appRefundChannelData.push(r.data[key])
                        }
                        console.log('num', num);
                        console.log('appRefundChannelData', this.appRefundChannelData);
                        this.appRefundChannelData = this.appRefundChannelData.splice(0, num) 
                        this.appRefundChannelData1.forEach((item) => {
                            this.appRefundChannelData.forEach(items => {
                                if (items.code == item.code) {
                                    item.count = items.count
                                    item.color = items.color
                                    item.name = items.name
                                    item.proportion = items.proportion
                                }
                            })
                        })
                    } else {
                        this.appRefundChannelData = []
                    }
                })
            },
            returnReasonDistribution () {
                this.returnReasonDistributionData = []
                return API.returnReasonDistribution(this.requireData).then((res) => {
                    if (res.ret === 0) {
                        if (res.data.returnRequestMap.length > 0) {
                            let data = res.data.returnRequestMap.filter(i => i.refund_reason !== 0)
                            data.map((i, index) => {
                                i.color = this.returnReasonOption[i.refund_reason].color
                            })
                            let dataList = data;
                            let Data = [
                                { count: '0', proportion: '0%', refund_reason: '4' },
                                { count: '0', proportion: '0%', refund_reason: '1' },
                                { count: '0', proportion: '0%', refund_reason: '2' },
                                { count: '0', proportion: '0%', refund_reason: '3' },
                                { count: '0', proportion: '0%', refund_reason: '5' },
                                { count: '0', proportion: '0%', refund_reason: '6' }
                            ];
                            Data.forEach(item => {
                                dataList.forEach(items => {
                                    if (items.refund_reason == item.refund_reason) {
                                        item.count = items.count
                                        item.proportion = items.proportion
                                        item.color = items.color
                                    }
                                })
                            })
                            this.returnReasonDistributionData = Data
                        } else {
                            this.returnReasonDistributionData = [
                                { count: '0', proportion: '0%', refund_reason: '4' },
                                { count: '0', proportion: '0%', refund_reason: '1' },
                                { count: '0', proportion: '0%', refund_reason: '2' },
                                { count: '0', proportion: '0%', refund_reason: '3' },
                                { count: '0', proportion: '0%', refund_reason: '5' },
                                { count: '0', proportion: '0%', refund_reason: '6' }
                            ]
                        }
                    } else {
                        this.returnReasonDistributionData = [
                            { count: '0', proportion: '0%', refund_reason: '4' },
                            { count: '0', proportion: '0%', refund_reason: '1' },
                            { count: '0', proportion: '0%', refund_reason: '2' },
                            { count: '0', proportion: '0%', refund_reason: '3' },
                            { count: '0', proportion: '0%', refund_reason: '5' },
                            { count: '0', proportion: '0%', refund_reason: '6' }
                        ];
                    }
                })
            },
            titleMean () {
                Dialog.alert({
                    title: '标题释义',
                    message: '平均每位游客退货数量=本区域退货申请总数 / 本区域退货申请人数'
                }).then(() => {
                    // on close
                });
            },
            // 添加时间作为筛选条件
            async timeChange (time) {
                if (time.length !== 0) {
                    this.requireData.startTime = time[0].replace(/\//g, '-');
                    this.requireData.endTime = time[1].replace(/\//g, '-');
                    
                    this.$store.state.refund.statisticalAnalysisTime.startTime = time[0].replace(/\//g, '-');
                    this.$store.state.refund.statisticalAnalysisTime.endTime = time[1].replace(/\//g, '-');
                    
                    await this.getInfo(''); // 请求所有图表数据
                    this.areaOrTimeChangeCallBack()
                }
            },
            // 添加区域作为筛选条件
            async areaChange (area) {
                this.requireData.reginCode = area;
                this.$store.state.refund.statisticalAnalysisReginCode = area

                console.log(this.requireData.reginCode, '888888')
                await this.getInfo('area'); // 请求所有图表数据
                this.areaOrTimeChangeCallBack()

            },
            areaOrTimeChangeCallBack() {
              let total = 0
              this.returnReasonDistributionData.map(i => {
                total += Number(i.count)
              })
              if (total == 0) {
                this.$emit('nodata', true)
              } else {
                this.$emit('nodata', false)
              }
            },
            toCommonList (item, index, type) {
                let typeList = [];
                // reason
                if (type == 'reason') {
                    this.returnReasonDistributionData.forEach((item) => {
                        // typeList.push({
                        //     F_NAME: this.returnReasonOption[item.refund_reason].name,
                        //     count: item.count
                        // });
                             item.F_NAME = this.returnReasonOption[item.refund_reason].name,
                            item.count = item.count
                    })
                    typeList = this.returnReasonDistributionData
                    typeList.forEach((item) => {
                        switch (item.F_NAME) {
                        case '发票/收据不正规':
                            item.refundReason = 3;
                            break;
                        case '不喜欢':
                            item.refundReason = 5;
                            break;
                        case '瑕疵商品':
                            item.refundReason = 2;
                            break;
                        case '价格虚高':
                            item.refundReason = 1;
                            break;
                        case '导游强制购物':
                            item.refundReason = 4;
                            break;
                        case '其他':
                            item.refundReason = 6;
                            break;
                        }
                    })
                    // travelModeInfo
                } else if (type == 'info') {
                    this.travelModeInfo.forEach((item) => {
                        // typeList.push({
                        //     F_NAME: item.name,
                        //     count: item.value
                        // });
                          item.F_NAME = item.name,
                            item.count = item.value
                    })
                    typeList = this.travelModeInfo
                    typeList.forEach((item) => {
                        switch (item.F_NAME) {
                        case '跟团游':
                            item.purchaseChannel = 1;
                            break;
                        case '自由行':
                            item.purchaseChannel = 2;
                            break;
                        }
                    })
                    // refundChannel
                } else if (type == 'channel') {
                  console.log('this.appRefundChannelData', this.appRefundChannelData);
                    this.appRefundChannelData1.forEach((item) => {
                        // typeList.push({
                        //     F_NAME: item.name,
                        //     count: item.count
                        // });
                         item.F_NAME = item.name,
                        item.count = item.count
                    })
                    typeList = this.appRefundChannelData1
                    typeList.forEach((item) => {
                        switch (item.F_NAME) {
                        case 'App在线退货':
                            item.refundChannel = 10;
                            break;
                        case '小程序在线退货':
                            item.refundChannel = 1;
                            break;
                        case '96301电话退货':
                            item.refundChannel = 2;
                            break;
                        case '退货中心退货':
                            item.refundChannel = 3;
                            break;
                        case 'App语音退货':
                            item.refundChannel = 4;
                            break;
                        case '诚信码退货':
                            item.refundChannel = 8;
                            break;
                        }
                    })
                }
                console.log('optionList', typeList);
                sessionStorage.removeItem('optionList');
                sessionStorage.setItem('optionList', JSON.stringify(typeList));
                // 跳转到公共列表
                this.$router.push({
                    path: '/refund/commonList',
                    query: {
                        activeIndex: index,
                        startTime: this.$store.state.refund.statisticalAnalysisTime.startTime,
                        endTime: this.$store.state.refund.statisticalAnalysisTime.endTime
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
.visitorAnalyze {
  font-family: PingFangSC-Semibold, PingFang SC;
  background-color: #f9fafc;
  padding: 12px 12px 90px;
  min-height: 100vh;
  .everItem {
    margin-bottom: 12px;
    background-color: white;
    border-radius: 2px;
  }
  .ChartModeBox {
    .headerTitle {
      min-height: 30px;
      font-size: 16px;
      font-weight: bold;
      padding-left: 16px;
      padding-top: 12px;
      line-height: 25px;
      box-sizing: border-box;
    }
    .ChartBox {
      // height: 318px;
    }
     /deep/.processing-satisfaction {
      //  .van-grid-item:nth-child(1) {
      //    flex-basis: 32% !important;
      //  }
      //  .van-grid-item:nth-child(2) {
      //    flex-basis: 34% !important;
      //  }
      //  .van-grid-item:nth-child(3) {
      //    flex-basis: 33% !important;
      //  }
      padding-left: 16px;
      .van-grid-item__content--center {
        padding-left: 0;
        padding-right: 0;
        .type {
          display: flex;
          width: 100%;
          align-items: center;
          .round {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 6px;
            background-color: red;
          }
          .greenRound {
            background-color: #3BC07C;
          }
          .blurRound {
            background-color: #66AEF8;
          }
          .orangeRound {
            background-color: #FFB469;
          }
          span {
            font-size: 12px;
            color: #71747A;
            font-weight: 400;
          }
        }
        .percentage {
          font-weight: Bold;
          font-size: 14px;
          color: #1E2226;
          padding-left: 25px;
          line-height: 25px;
          width: 100%;
        }
        .number {
          font-size: 12px;
          color: #71747A;
          font-weight: 400;
          display: flex;
          align-items: center;
          padding-left: 12px;
          line-height: 17px;
          width: 100%;
        }
      }
    }
  }
  .salesMean {
    height: 81px;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .itemTitleBox {
      font-size: 14px;
      margin-top: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-left: 4px;
        height: 16px;
        width: 16px;
        display: inline-block;
      }
    }
    .numBox {
      font-size: 24px;
      font-weight: bold;
      margin-top: 9px;
      span {
        display: inline-block;
        margin-left: 1px;
        font-size: 14px;
      }
    }
  }
  .tripMode {
    .headerTitle {
      min-height: 35px;
      font-size: 16px;
      font-weight: bold;
      padding-left: 16px;
      padding-top: 12px;
      line-height: 25px;
      box-sizing: border-box;
    }
    .doucghnutChartBox {
      padding-top: 20px;
      padding-bottom: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      .doughnutDetail {
        margin-left: 18px;
        min-width: 110px;
        .itemBox {
          padding: 8px 0;
          span {
            display: inline-block;
          }
          .topBox {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .iconBox {
              margin-right: 6px;
              width: 8px;
              height: 8px;
              border-radius: 4px;
            }
            .nameBox {
              line-height: 25px;
              font-size: 14px;
              margin-right: 2px;
            }
            .percent {
              line-height: 25px;
              font-size: 16px;
              font-weight: 600;
            }
          }
          .bottomBox {
            display: flex;
            align-items: center;
            .van-icon-arrow:before {
              font-size: 12px;
            }
            .numBox {
              padding-left: 14px;
              font-size: 14px;
              color: #71747a;
            }
            .icon {
              position: relative;
              top: 1px;
            }
          }
        }
      }
    }
  }
  .sourceMode {
    .headerTitle {
      min-height: 34px;
      font-size: 16px;
      font-weight: bold;
      padding-left: 16px;
      padding-top: 12px;
      line-height: 25px;
      box-sizing: border-box;
    }
    .BarChart {
      height: 260px;
      padding: 0 16px;
      position: relative;
    //   .arrow {
    //   position: absolute;
    //   right: 7px;
    // bottom: 18px;
    //   }
    }
  }
  .ageMode {
    .headerTitle {
      min-height: 30px;
      font-size: 16px;
      font-weight: bold;
      padding-left: 16px;
      padding-top: 8px;
      line-height: 25px;
      box-sizing: border-box;
    }
    .RefererChart {
      height: 248px;
    }
  }
}
</style>
